import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import { createPinia } from 'pinia';
import piniaPersistedState from 'pinia-plugin-persistedstate';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import './styles/main.scss';
import { setupPermissionsDirective } from './directives/permissions';
import currencyPlugin from './plugins/currency';
import dateTimePlugin from './plugins/datetime';

// Pinia store setup
import { useAuthStore } from '@/store/auth';
import { useThemeStore } from './store/themeStore';


// Load fonts
loadFonts();

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPersistedState);
app.use(pinia); // ✅ Ensure Pinia is registered before using stores

const authStore = useAuthStore();

authStore.initializeUser().then(() => {
  app.use(router); // ✅ Register router before mounting
  app.use(vuetify);
  app.use(currencyPlugin);
  app.use(dateTimePlugin); // ✅ Register Vuetify before mounting
  setupPermissionsDirective(app); // ✅ Setup directives before mounting

  // Theme store setup
  const themeStore = useThemeStore();
  themeStore.initTheme();

  // ✅ Finally, mount the app
  app.mount('#app');
});
